<app-card-widget title="PCR Reports" *ngIf="invoice?.is_pcr_reportable">
  <mat-card-content>
    <div class="card-section-container" *ngIf="tasks$ | async as tasks">
      <div class="card-section list-section">
        <mat-nav-list>
          <mat-list-item *ngFor="let task of tasks" (click)="selectTask(task)" [class.selected]="task === selectedTask">
            <div class="task-row">
              <div class="task-info">
                <div class="task-type">{{ task.task_type }}</div>
                <div class="task-date">{{ task.created_at | date:'short' }}</div>
              </div>
              <div class="task-status">
                <span class="status-badge" [ngClass]="task.status | lowercase">{{ task.status }}</span>
              </div>
            </div>
          </mat-list-item>
        </mat-nav-list>
        <div *ngIf="tasks.length === 0" class="no-data">
          No PCR reports found.
        </div>
      </div>

      <div class="card-section details-section" *ngIf="selectedTask">
        <h3>Details</h3>
        <app-text label="ID">{{ selectedTask.id }}</app-text>
        <app-text label="Type">{{ selectedTask.task_type }}</app-text>
        <app-text label="Status">{{ selectedTask.status }}</app-text>
        <app-text label="Created">{{ selectedTask.created_at | date:'medium' }}</app-text>
        <app-text label="Updated">{{ selectedTask.updated_at | date:'medium' }}</app-text>
        <app-text label="Reference">{{ selectedTask.report_reference }}</app-text>
        <app-text label="Last Attempt" *ngIf="selectedTask.last_attempt_at">{{ selectedTask.last_attempt_at | date:'medium' }}</app-text>

        <div *ngIf="selectedTask.pcr_error_response" class="error-details">
            <h4>Error Details</h4>
            <pre>{{ selectedTask.pcr_error_response | json }}</pre>
        </div>
      </div>
    </div>
  </mat-card-content>
</app-card-widget>
